<template>
  <div v-if="showModal" class="custom-modal-overlay" @click.self="closeModal">
    <div class="custom-modal modal-fullscreen gps-modal">
      <header class="custom-modal-header">
        <h5 class="custom-modal-title">{{ modalTitle }}</h5>
        <button
          class="custom-modal-close"
          @click="closeModal"
          aria-label="Close"
        >
          &times;
        </button>
      </header>
      <section class="session-metrics">
        <div class="gps-tabs-container">
          <nav class="gps-tab-nav">
            <button
              :class="['tab-btn', { active: activeTab === 'overview' }]"
              @click="$emit('update:activeTab', 'overview')"
            >
              Overview
            </button>
            <button
              :class="['tab-btn', { active: activeTab === 'detailed' }]"
              @click="$emit('update:activeTab', 'detailed')"
            >
              Detailed Metrics
            </button>
          </nav>
        </div>
        <div class="gps-tab-content">
          <slot name="overview" v-if="activeTab === 'overview'"></slot>
          <slot name="detailed" v-if="activeTab === 'detailed'"></slot>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "GPSModal",
  props: {
    showModal: { type: Boolean, required: true },
    modalTitle: { type: String, required: true },
    activeTab: { type: String, required: true },
  },
  emits: ["update:activeTab", "update:showModal"],
  methods: {
    closeModal() {
      this.$emit("update:showModal", false);
    },
  },
};
</script>

<style scoped>
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.custom-modal {
  background: #fff;
  border-radius: 10px;
  max-width: 900px;
  width: 100%;
  max-height: 95vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  position: relative;
  padding-bottom: 2rem;
}

.modal-fullscreen {
  max-width: 95% !important;
  max-height: 95vh !important;
}

.custom-modal-header {
  display: flex;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 1.25rem !important;
  border-bottom: 1px solid #dee2e6 !important;
  background-color: #f8f9fa;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.custom-modal-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}

.custom-modal-close {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #888;
  transition: color 0.2s;
  padding: 0;
}

.custom-modal-close:hover {
  color: #333;
}

.gps-tabs-container {
  margin-bottom: 1rem;
  padding: 1rem;
}

.gps-tab-content {
  padding: 1rem;
}

.tab-btn.active {
  font-weight: bold;
}

.gps-tabs-container .gps-tab-nav .tab-btn {
  background: none;
  border: none;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  color: #6c757d;
  cursor: pointer;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
}

.gps-tabs-container .gps-tab-nav .tab-btn.active {
  color: #47a9f9;
  border-bottom-color: #47a9f9;
  background-color: rgba(71, 169, 249, 0.1);
}
</style>
